<template>
  <div class="sponsor-page">
    <div v-if="seasonType.sponsor">
      <div class="sub-sponsor">
        <p class="title">MAIN</p>
        <div class="sub-item-div">
          <div v-for="(item, index) in mainList" :key="index">
            <component
              :is="item.url ? 'a' : 'div'"
              :href="item.url || null"
              :target="item.url ? '_blank' : null"
              :rel="item.url ? 'noopener noreferrer' : null"
              class="subItem"
            >
              <img :src="imageSrc(item.img)" :alt="item.title">
            </component>
          </div>
        </div>
      </div>

      <div class="sub-sponsor">
        <p class="title">MEDICAL</p>
        <div class="sub-item-div">
          <div v-for="(item, index) in medicalList" :key="index">
            <component
              :is="item.url ? 'a' : 'div'"
              :href="item.url || null"
              :target="item.url ? '_blank' : null"
              :rel="item.url ? 'noopener noreferrer' : null"
              class="subItem"
            >
              <img :src="imageSrc(item.img)" :alt="item.title">
            </component>
          </div>
        </div>
      </div>

      <div class="sub-sponsor">
        <p class="title">POSCO OFFICIAL</p>
        <div class="sub-item-div">
          <div v-for="(item, index) in poscoList" :key="index">
            <component
              :is="item.url ? 'a' : 'div'"
              :href="item.url || null"
              :target="item.url ? '_blank' : null"
              :rel="item.url ? 'noopener noreferrer' : null"
              class="subItem"
            >
              <img :src="imageSrc(item.img)" :alt="item.title">
            </component>
          </div>
        </div>
      </div>

      <div class="sub-sponsor">
        <p class="title">DRAGONS OFFICIAL</p>
        <div class="sub-item-div">
          <div v-for="(item, index) in officialList" :key="index">
            <component
              :is="item.url ? 'a' : 'div'"
              :href="item.url || null"
              :target="item.url ? '_blank' : null"
              :rel="item.url ? 'noopener noreferrer' : null"
              class="subItem"
            >
              <img :src="imageSrc(item.img)" :alt="item.title">
            </component>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <PageComingSoon :titleText="' '" :descriptionText="'준비 중입니다.'" />
    </div>
  </div>
</template>

<script>

import PageComingSoon from '@/components/Common/PageComingSoon';

export default {
  name: 'Sponsor',
  components: {PageComingSoon},
  data() {
    return {
      mainList: [],
      medicalList: [],
      poscoList: [],
      officialList: [],
      seasonType: this.$store.getters['getSeasonType'],
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init() {
      this.mainList = [
        {
          title: '포스코',
          img: 'main_sponsor_01',
          url: 'https://www.posco.co.kr/homepage/docs/kor7/jsp/s91a0000001i.jsp'
        }, {
          title: '전남',
          img: 'main_sponsor_02',
          url: 'https://www.jeonnam.go.kr/'
        }, {
          title: '광양',
          img: 'main_sponsor_03',
          url: 'https://gwangyang.go.kr/'
        }, {
          title: '포스코인터내셔널',
          img: 'main_sponsor_04',
          url: 'https://www.poscointl.com/'
        }, {
          title: '동광양농협',
          img: 'main_sponsor_05',
          url: 'https://dgynh.nonghyup.com/user/indexMain.do?siteId=dgynh'
        }, {
          title: '케이앤',
          img: 'main_sponsor_06',
          url: 'http://www.keien.co.kr/'
        },
      ];

      this.medicalList = [
        {
          title: '순천에스병원',
          img: 'medical_sponsor_01',
          url: 'https://xn--om3bv0hxlx8hwpbk0t.com/'
        },
      ];

      this.poscoList = [
        {
          title: '포스코이앤씨',
          img: 'posco_sponsor_01',
          url: 'https://www.poscoenc.com:446/ko/index.aspx'
        }, {
          title: '포스코DX',
          img: 'posco_sponsor_02',
          url: 'https://www.poscodx.com/kor/'
        },{
          title: '포스코플로우',
          img: 'posco_sponsor_03',
          url: 'https://www.poscoflow.com/'
        }, {
          title: '포스코와이드',
          img: 'posco_sponsor_04',
          url: 'https://www.poscowide.com/'
        }, {
          title: '포스코엠텍',
          img: 'posco_sponsor_05',
          url: 'https://www.poscomtech.com/'
        }, {
          title: '포스코MC머티리얼즈',
          img: 'posco_sponsor_06',
          url: 'https://www.poscomcm.com/kor/index.do;jsessionid=6566BB373754E7BE064F4964641B5312'
        }, {
          title: '엔투비',
          img: 'posco_sponsor_07',
          url: 'https://www.entob.com/'
        }, {
          title: '포스코휴먼스',
          img: 'posco_sponsor_08',
          url: 'https://www.poscohumans.com/kr/main.do'
        }, {
          title: '포스코GYS테크',
          img: 'posco_sponsor_09',
          url: 'https://www.poscogystech.com/'
        }, {
          title: '포스코GYR테크',
          img: 'posco_sponsor_10',
          url: 'https://www.poscogyrtech.com/'
        }, {
          title: '포스코GY솔루션',
          img: 'posco_sponsor_11',
          url: 'https://www.poscogysolution.com/'
        }, {
          title: '포스코스틸리온',
          img: 'posco_sponsor_12',
          url: 'https://www.poscosteeleon.com/kr/main.do'
        }, {
          title: 'SNNC',
          img: 'posco_sponsor_13',
          url: 'https://www.snnc.co.kr/'
        },
      ];

      this.officialList = [
        {
          title: '여수광양항만공사',
          img: 'official_sponsor_01',
          url: 'https://www.ygpa.or.kr/hmpg/ygpa/main.do'
        },
        {
          title: '광양상공회의소',
          img: 'official_sponsor_02',
          url: 'https://gwangyangcci.korcham.net/front/user/main.do'
        },
        {
          title: '보성군청',
          img: 'official_sponsor_03',
          url: 'https://www.boseong.go.kr/intro.html'
        },
        {
          title: '서희건설',
          img: 'official_sponsor_04',
          url: 'https://seohee.co.kr/home/seohees/base/index.php'
        },
        {
          title: '조선내화',
          img: 'official_sponsor_05',
          url: 'https://www.chosunref.co.kr/'
        },
        {
          title: 'CJ프레시웨이',
          img: 'official_sponsor_06',
          url: 'https://www.cjfreshway.com/index.jsp'
        },
        {
          title: '디오션리조트',
          img: 'official_sponsor_07',
          url: 'https://www.theoceanresort.co.kr/'
        },
        {
          title: '광양기업',
          img: 'official_sponsor_08',
          url: 'http://www.kyec.co.kr/web/'
        },
        {
          title: '디와이이',
          img: 'official_sponsor_09',
          url: 'http://ecodooyang.com/'
        },
        {
          title: '동후',
          img: 'official_sponsor_10',
          url: 'http://donghoo.kr/?act=main'
        },
        {
          title: '코스원',
          img: 'official_sponsor_11',
          url: ''
        },
        {
          title: '태운',
          img: 'official_sponsor_12',
          url: ''
        },
        {
          title: '포운',
          img: 'official_sponsor_13',
          url: ''
        },
        {
          title: '화인',
          img: 'official_sponsor_14',
          url: ''
        },
        {
          title: '삼진기업',
          img: 'official_sponsor_15',
          url: ''
        },
        {
          title: '정원',
          img: 'official_sponsor_16',
          url: 'https://jeongwon.clickn.co.kr/'
        },
        {
          title: '대진',
          img: 'official_sponsor_17',
          url: ''
        },
        {
          title: '신진기업',
          img: 'official_sponsor_18',
          url: ''
        },
        {
          title: '효석',
          img: 'official_sponsor_19',
          url: ''
        },
        {
          title: '피디텍',
          img: 'official_sponsor_20',
          url: 'http://www.pdtec.co.kr/'
        },
        {
          title: '대동중공업',
          img: 'official_sponsor_21',
          url: 'http://www.ddhi.co.kr/'
        },
        {
          title: '만보중공업',
          img: 'official_sponsor_22',
          url: 'https://manbohi.co.kr/'
        },
        {
          title: 'bhi',
          img: 'official_sponsor_23',
          url: 'https://www.bhi.co.kr/'
        },
        {
          title: '아이엠 스트롱',
          img: 'official_sponsor_24',
          url: 'https://instagram.com/iamstrong_kr/'
        }
      ];
    },
    imageSrc(imgSrc) {
      return require('@/assets/img/club/sponsor/'+imgSrc+'.svg');
    },
  }
}
</script>
